<form [formGroup]="form">
    <quill-editor #editor class="editor" format="html" formControlName="html" (onContentChanged)="contentChanged($event)"></quill-editor>
</form>
<button mat-flat-button color="primary" class="revert-button" *ngIf="hasHistory" (click)="revertChanges()">Revert</button>
<button mat-flat-button color="primary" class="text-save-button" (click)="saveChanges()">Save</button>